var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 341.47 275.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1,\n      .cls-2 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n      }\n      .cls-1 {\n        stroke: #5d3233;\n        stroke-width: 20px;\n      }\n      .cls-2 {\n        stroke: #3d3327;\n        stroke-width: 14px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.42,235.18s98.24,68.66,206,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.36,23.65S265.23-16.53,334.47,28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7,34.76S52.21-11.69,126.65,23.41"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.a9dce5d8.svg";
export { ForwardRef as ReactComponent };